import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactComponent } from './pages/contact/contact.component';
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { SpecialisatiesComponent } from './pages/specialisaties/specialisaties.component';
import { TeamComponent } from './pages/team/team.component';
import { PraktischComponent } from './pages/praktisch/praktisch.component';
import { TeamlidComponent } from './pages/teamlid/teamlid.component';
import { VestigingComponent } from './pages/vestiging/vestiging.component';
import { VisieComponent } from './pages/visie/visie.component';
import { VacaturesComponent } from './pages/vacatures/vacatures.component';
import { SpecialisatieComponent } from './pages/specialisatie/specialisatie.component';
import { CookiesComponent } from './pages/cookies/cookies.component';
import { VacatureComponent } from './pages/vacature/vacature.component';
import { UnderconstructionComponent } from './pages/underconstruction/underconstruction.component';
import { ContactSimpleComponent } from './pages/contact-simple/contact-simple.component';
import { DisciplineComponent } from './pages/discipline/discipline.component';
import { DisciplinesComponent } from './pages/disciplines/disciplines.component';
import { VormingenComponent } from './pages/vormingen/vormingen.component';
import { VormingComponent } from './pages/vorming/vorming.component';
import { SpecLogoPraktischComponent } from './pages/spec-logo-praktisch/spec-logo-praktisch.component';
import { InfoboxComponent } from './pages/infobox/infobox.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'team', component: TeamComponent },
  { path: 'teamlid', component: TeamlidComponent },
  { path: 'vestiging', component: VestigingComponent },
  { path: 'disciplines', component: DisciplinesComponent },
  { path: 'discipline', component: DisciplineComponent },
  { path: 'specialisatie', component: SpecialisatieComponent },
  { path: 'praktisch', component: PraktischComponent },
  { path: 'visie', component: VisieComponent },
  { path: 'vacatures', component: VacaturesComponent },
  { path: 'vacature', component: VacatureComponent },
  { path: 'vorming', component: VormingComponent },
  { path: 'vormingen', component: VormingenComponent },
  { path: 'infobox', component: InfoboxComponent },
  { path: 'cookies', component: CookiesComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'spec-logo-praktisch', component:SpecLogoPraktischComponent},
  { path: '',   redirectTo: '/home', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent },
  /*{ path: 'underconstruction',   component: UnderconstructionComponent },
  { path: 'contact-underconstruction',   component: ContactSimpleComponent },
  { path: '',   redirectTo: '/underconstruction', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }*/
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
